import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";
export const fetchMerchants = createAsyncThunk("giftMerchantManagement/fetchAssets",
	async () => {
		const response = await apiConfig.get("merchant-management/list");
		console.log("Merchnat List:{}",response);
		return response;
	}
);
export const toggelDeleteGiftMerchant = createAsyncThunk("giftMerchantManagement/toggelDelete", async (merchantId) => {
	const response = await apiConfig.delete(`merchant-management/delete/${merchantId}`);
	const data = await response.data;
	return data;
});


export const addNewMerchant = createAsyncThunk("giftMerchantManagement/addNewMerchant", async (rec_data) => {
	const formData = new FormData();
	console.log("before send",rec_data)
	if (rec_data.image != null) {
		console.log("upload new image")
		formData.append("file", rec_data.image, rec_data.image.name);
		const response = await apiConfig.post(`merchant-management/upload`, formData);
		const data = await response.data.data;
		console.log("response imges:",data)

		//TODO update
		rec_data.CategoryData.imageUrl = data.csImageUlr;
		rec_data.CategoryData.imageUrlGcp = data.gcpImageUrl;
	}
	console.log("after update:", rec_data.CategoryData)
	console.log("mood:",rec_data.isUpdate)
	if (!rec_data.isUpdate) {
		const responseWrapper = await apiConfig.post(`merchant-management/add`, rec_data.CategoryData);
		return responseWrapper;
	} else {
		console.log("mood update:",rec_data.isUpdate)

		// update action
		const responseWrapper = await apiConfig.put(`merchant-management/update/${rec_data.CategoryData.id}`, rec_data.CategoryData);
		return responseWrapper;
	}

});
const giftMerchantManagementSlice = createSlice({
	name: "giftMerchantManagement",
	initialState: {
		assets: [],
		status: null,
		error: null,
	},
	reducers: {},
	extraReducers: {
		[fetchMerchants.pending]: (state) => {
			console.log("Pending")
			state.status = "loading";
		},
		[fetchMerchants.fulfilled]: (state, action) => {
			const response = action.payload.data;
			if (response.status === "OK") {
				state.status = "OK";
				state.assets = action.payload.data.data;
			} else {
				state.status = "failed";
				//state.error = action.error.message;
			}
		},
		[fetchMerchants.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
		},
		[toggelDeleteGiftMerchant.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.id);
				state.assets[itemIndex] = action.payload.data;
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
		[addNewMerchant.fulfilled]: (state, action) => {
			const response = action.payload.data;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.data.id);
				if (itemIndex ===-1) {
					state.assets = [...state.assets, action.payload.data.data];
				} else {

					state.assets[itemIndex] = action.payload.data.data;
				}
			}
			else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
	},
});
export const assetManagementActions = giftMerchantManagementSlice.actions;
export default giftMerchantManagementSlice.reducer;
